import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  paymentDetails: {},
  requiredPaymentParams: {},
  paymentCompletedDetails: {},
}

const paymentSlice = createSlice({
  name: 'paymentSlice',
  initialState,
  reducers: {
    setPaymentDetails: (state, action) => {
      state.paymentDetails = { ...action.payload }
    },
    setRequiredPaymentParams: (state, action) => {
      state.requiredPaymentParams = action.payload
    },
    setPurchasePlanNoPayment: (state, action) => {
      state.purchasePlanNoPayment = action.payload
    },
    setPaymentCompletedDetails: (state, action) => {
      state.paymentCompletedDetails = action.payload
    },
  },
})

export default paymentSlice.reducer

export const { setPaymentDetails, setRequiredPaymentParams, setPurchasePlanNoPayment, setPaymentCompletedDetails } = paymentSlice.actions
